module.exports = __webpack_public_path__ + "static/media/devpost.f5748073.svg";